import { Box, Flex } from '@cowsquare/design';
import gql from 'graphql-tag';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import { getQueryObject } from '../../../utils/getQueryObject';
import { useAdsQuery, usePagesBindingUrl } from '../../../utils/hooks';
import { Advertisements } from '../../Advertisements';
import { ArticleCardList } from '../../ArticleCardList';
import { ArticleCardListLoading } from '../../Loading';
import { Section } from '../../Section';
import { Title } from '../../Title';

const PAGE_SIZE = 20;

const GET_ABOUT_US = gql`
  query getAboutUs($limit: Int, $offset: Int) {
    total: hkdutest_about_us_aggregate {
      aggregate {
        count
      }
    }

    list: hkdutest_about_us(limit: $limit, order_by: { created_at: desc }, offset: $offset) {
      id
      author {
        real_avatar
        name
        email
      }
      name
      content
      cover_file {
        link
      }
      created_at
    }
  }
`;

const AboutUsList = ({ location, uri }) => {
  const queryObject = getQueryObject(location);
  const [page, onPageChange] = usePagesBindingUrl(queryObject, uri);
  const { ads } = useAdsQuery(uri);

  return (
    <Query
      query={GET_ABOUT_US}
      variables={{
        limit: PAGE_SIZE,
        offset: (page - 1) * PAGE_SIZE,
      }}
    >
      {({ data, loading }) => {
        const list = R.propOr([], 'list', data);
        const total = R.pathOr(0, ['total', 'aggregate', 'count'], data);

        return (
          <Section>
            <Helmet>
              <title>About Us - HKDU Public</title>
            </Helmet>
            <Advertisements ads={ads} />
            <Box px={[5, 0]} pt={8}>
              <Box mb={5}>
                <Flex flexDirection={['column', 'row']} justifyContent="space-between">
                  <Title m={0} mb={[5, 0]}>
                    About Us
                  </Title>
                </Flex>
              </Box>
              <Box pb={8}>
                {R.and(R.isEmpty(list), loading) && <ArticleCardListLoading />}
                <ArticleCardList
                  uri={uri}
                  page={page}
                  onPageChange={onPageChange}
                  list={list}
                  total={total}
                />
              </Box>
            </Box>
          </Section>
        );
      }}
    </Query>
  );
};

export default AboutUsList;
